import React, { memo } from "react";
import { ReminderIcon, ReminderClearIcon } from "modules/icons";
import { HStack, Text } from "@chakra-ui/react";
import colors from "app/colors";
import { Moment } from "moment";

interface IProps {
  remindTime?: Moment;
}

const MessageThreadToggleReminderToast = ({ remindTime }: IProps) => (
  <HStack
    backgroundColor={colors.blackTertiary}
    height={50}
    borderRadius={7}
    p={2}
    w="fit-content"
  >
    {remindTime ? (
      <ReminderIcon boxSize={5} fill={colors.white} />
    ) : (
      <ReminderClearIcon boxSize={5} fill={colors.white} />
    )}
    <Text color={colors.white} fontSize={14}>
      {remindTime ? "Reminder has been created" : "Reminder cleared"}
    </Text>
  </HStack>
);

export default memo(MessageThreadToggleReminderToast);
